export interface StringDevtoolState {
  active: boolean;
}

export interface StringDevtoolDefinition {
  id: string;
  label: string;
  icon: string;
  order?: number;
  getState: () => StringDevtoolState;
  setActive: (active: boolean) => void;
  subscribe?: (listener: (state: StringDevtoolState) => void) => () => void;
}

export interface StringDevtoolProvider {
  getDevtoolDefinition(): StringDevtoolDefinition | null;
}

export function isStringDevtoolProvider(value: unknown): value is StringDevtoolProvider {
  return (
    typeof value === "object" &&
    value !== null &&
    "getDevtoolDefinition" in value &&
    typeof (value as StringDevtoolProvider).getDevtoolDefinition === "function"
  );
}
